<template>
  <div>
    <div class="card-body py-0 px-0 border border-gray rounded-3">
      <div class="card-header bg-gray">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-filter text-white me-2"></i>Filtros de Novedades
          </h5>
          <button
            type="button"
            class="btn bg-navy btn-sm"
            @click="cargarDatos"
            :disabled="cargando"
          >
            <i
              class="fas fa-sync-alt me-1"
              :class="{ 'fa-spin': cargando }"
            ></i>
            Actualizar
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-dark"
            @click="mostrarFiltros = !mostrarFiltros"
            :title="mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
          >
            <i
              :class="
                mostrarFiltros ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
              "
            ></i>
            {{ mostrarFiltros ? "Ocultar" : "Mostrar" }}
          </button>
        </div>
      </div>
      <div class="card-body bg-light" v-show="mostrarFiltros">
        <div class="row">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-building text-primary me-1"></i> Empresa
            </label>
            <v-select
              v-model="empresa"
              :options="listasForms.empresas"
              label="razon_social"
              placeholder="Todas las empresas"
              class="form-control-sm p-0"
              @input="getSelectEmpresa()"
              @search="buscarEmpresas"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-truck text-warning me-1"></i> Vehículo
            </label>
            <v-select
              v-model="vehiculo"
              :options="listasForms.vehiculos"
              label="placa"
              placeholder="Todos los vehículos"
              class="form-select"
              @input="getSelectVehiculo()"
              @search="buscarVehiculos"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-user text-secondary me-1"></i> Conductor
            </label>
            <v-select
              v-model="conductor"
              class="form-select"
              :options="listasForms.conductores"
              label="nombre"
              placeholder="Todos los conductores"
              @input="getSelectConductor()"
              @search="buscarConductores"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-truck text-warning me-1"></i> Remolque
            </label>
            <v-select
              v-model="remolque"
              class="form-select"
              :options="listasForms.remolques"
              label="placa"
              placeholder="Todos los remolques"
              @input="getSelectRemolque()"
              @search="buscarRemolques"
            ></v-select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Desde
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_inicial"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Hasta
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_final"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted">
              <i class="fas fa-route text-danger me-1"></i> Tipo Servicio
            </label>
            <select
              class="form-control form-control-sm"
              v-model="filtros.tipo_servicio"
              placeholder="Seleccione el tipo de servicio"
              @change="cargarDatos"
            >
              <option value="">Seleccione...</option>
              <option value="1">Tep Viajes</option>
              <option value="2">Tif Turno</option>
              <option value="3">Tep Turno</option>
              <option value="4">Planta Externa Viajes</option>
            </select>
          </div>
          <div class="col-md-3 mt-2">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-hashtag text-danger me-1"></i>
              Servicio
            </label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model="filtros.entidad_id"
              placeholder="Ej: 12345"
              :disabled="!filtros.tipo_servicio"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-success btn-sm"
                @click="cargarDatos"
                :disabled="cargando"
              >
                <i class="fas fa-search me-1" v-if="!cargando"></i>
                <i class="fas fa-spinner fa-spin me-1" v-else></i>
                {{ cargando ? "Buscando..." : "Buscar" }}
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="limpiarFiltros"
              >
                <i class="fas fa-eraser me-1"></i> Limpiar Filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de Novedades -->
    <div class="card shadow mt-2">
      <div class="card-header bg-gradient-secondary text-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-list me-2"></i> Novedades
            <span class="badge bg-light text-dark ml-1"
              >{{ novedades.total }} registros</span
            >
          </h5>
        </div>
      </div>
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center p-4">
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2">Cargando datos...</p>
        </div>
        <div
          v-else-if="!novedades.data || novedades.data.length === 0"
          class="text-center p-4"
        >
          <i class="fas fa-info-circle fa-3x text-muted mb-3"></i>
          <p class="text-muted">No hay novedades disponibles</p>
        </div>
        <div v-else class="table-responsive">
          <table
            class="table table-striped table-hover mb-0 text-nowrap table-bordered"
          >
            <thead class="table-dark">
              <tr>
                <th>Acciones</th>
                <th>Tipo Entidad</th>
                <th>ID Entidad</th>
                <th>Fecha Novedad</th>
                <th>Relevancia</th>
                <th>Tipo Novedad</th>
                <th>Subnovedad</th>
                <th>Vehículo</th>
                <th>Conductor</th>
                <th>Remolque</th>
                <th>Transportadora</th>
                <th>Latitud</th>
                <th>Longitud</th>
                <th>Dirección - Velocidad</th>
                <th>Estado Novedad</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in novedades.data"
                :key="index"
                class="text-center"
              >
                <td>
                  <div style="position: static; z-index: auth">
                    <button
                      type="button"
                      class="btn btn-dark btn-sm"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-align-justify"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        style="cursor: pointer"
                        @click="abrirModal(item, item.vehiculo?.gpss)"
                      >
                        <i class="fa fa-map-signs"></i>
                        Crear Seguimiento
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      item.entidad_type == 'App\\TepViajes'
                        ? 'bg-primary'
                        : item.entidad_type == 'App\\TifTurnos'
                        ? 'bg-success'
                        : item.entidad_type == 'App\\PlantViaje'
                        ? 'bg-navy'
                        : 'bg-info'
                    "
                  >
                    {{
                      item.entidad_type == "App\\TepViajes"
                        ? "Tep Viajes"
                        : item.entidad_type == "App\\TifTurnos"
                        ? "Tif Turno"
                        : item.entidad_type == "App\\TepTurno"
                        ? "Tep Turno"
                        : item.entidad_type == "App\\PlantViaje"
                        ? "Planta Externa Viaje"
                        : "N/A"
                    }}
                  </span>
                </td>
                <td class="text-center">
                  <strong>{{ item.entidad_id || "N/A" }}</strong>
                </td>
                <td class="text-center">
                  <small class="text-muted">{{
                    item.fecha_novedad || "N/A"
                  }}</small>
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      item.relevancia == 1
                        ? 'bg-warning'
                        : item.relevancia == 2
                        ? 'bg-danger'
                        : 'bg-info'
                    "
                  >
                    {{ item.nRelevancia || "N/A" }}
                  </span>
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      item.tipo_novedad == 1
                        ? 'bg-info'
                        : item.tipo_novedad == 2
                        ? 'bg-primary'
                        : item.tipo_novedad == 3
                        ? 'bg-navy'
                        : 'bg-light'
                    "
                  >
                    {{ item.nTipoNovedad || "N/A" }}
                  </span>
                </td>
                <td class="text-center">
                  {{
                    item.tipo_novedad == 1
                      ? item.nSubNovedadGps
                      : item.tipo_novedad == 2
                      ? item.nSubNovedadRuta
                      : item.tipo_novedad == 4
                      ? item.nSubNovedadGeocerca
                      : "N/A"
                  }}
                </td>
                <td class="text-center">
                  {{ item.entidad?.vehiculo?.placa || "N/A" }}
                </td>
                <td class="text-center">
                  {{
                    item.entidad?.conductor?.nombres +
                      " " +
                      item.entidad?.conductor?.apellidos || "N/A"
                  }}
                  <strong>
                    {{ item.entidad?.conductor?.celular_principal || "N/A" }}
                    <a
                      :href="
                        'https://wa.me/' +
                          item.entidad?.conductor?.celular_principal
                      "
                      target="_blank"
                      ><i class="fab fa-whatsapp-square fa-lg"></i></a
                  ></strong>
                  <span class="d-block">
                    <small class="text-muted">{{
                      item.entidad?.conductor?.numero_documento || "N/A"
                    }}</small>
                  </span>
                </td>
                <td class="text-center">
                  {{ item.entidad?.remolque?.placa || "N/A" }}
                </td>
                <td class="text-center">
                  {{ item.empresa?.razon_social || "N/A" }}
                </td>
                <td class="text-center">
                  {{ item.latitud || "N/A" }}
                </td>
                <td class="text-center">
                  {{ item.longitud || "N/A" }}
                </td>
                <td class="text-center">
                  {{ item.direccion || "N/A" }} -
                  {{
                    item.velocidad != null ? item.velocidad + " km/h" : "N/A"
                  }}
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      item.nEstado == 'Pendiente' ? 'bg-warning' : 'bg-info'
                    "
                  >
                    {{ item.nEstado || "N/A" }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Paginación compacta -->
      <div class="card-footer bg-light pb-0" v-if="!cargando">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div
              v-if="novedades.total"
              class="text-muted"
              style="font-size: 0.8rem"
            >
              <i class="fas fa-info-circle me-1"></i>
              Mostrando del
              <strong>{{ novedades.from }}</strong> al
              <strong>{{ novedades.to }}</strong> de un total:
              <strong>{{ novedades.total }}</strong> Registros
            </div>
            <div class="pb-2" v-else>
              <span class="badge bg-danger" style="font-size: 0.75rem">
                <i class="fas fa-exclamation-triangle me-1"></i>
                No hay registros para mostrar
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <pagination
                :data="novedades"
                @pagination-change-page="cargarDatos"
                :limit="5"
                class="float-right"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import pagination from "laravel-vue-pagination";

const $ = window.$;

export default {
  name: "GestionNovedades",
  components: {
    vSelect,
    pagination,
  },
  data() {
    return {
      cargando: false,
      novedades: {},
      filtros: {
        tipo_servicio: null,
        entidad_id: null,
        empresa_id: null,
        vehiculo_id: null,
        conductor_id: null,
        remolque_id: null,
        fecha_inicial: null,
        fecha_final: null,
      },
      empresa: {},
      vehiculo: {},
      remolque: {},
      conductor: {},
      listasForms: {
        empresas: [],
        vehiculos: [],
        remolques: [],
        conductores: [],
      },
      mostrarFiltros: true,
    };
  },
  computed: {
    fechaMaxima() {
      return moment().format("YYYY-MM-DD");
    },
  },

  methods: {
    init() {
      this.cargarDatos();
    },

    abrirModal(novedad, gps) {
      this.$parent.$refs.SeguimientoNovedades.init("novedades", novedad, gps);
      this.$nextTick(() => {
        $("#modal-form-seguimiento-novedades").modal("show");
      });
    },

    gpsDentroDe2Horas(fecha) {
      if (!fecha) return false;
      const haceDosHoras = moment().subtract(2, "hours");
      return moment(fecha).isAfter(haceDosHoras);
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/empresas/lista?razon_social=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3, 5, 17],
            },
          })
          .then(function(response) {
            me.listasForms.empresas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/vehiculos/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              lineas_negocio_id: [3, 5, 17],
            },
          })
          .then(function(response) {
            me.listasForms.vehiculos = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductores(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3, 5, 17],
            },
          })
          .then(function(response) {
            me.listasForms.conductores = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/remolques/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3, 17],
            },
          })
          .then(function(response) {
            me.listasForms.remolques = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async cargarDatos(page = 1) {
      this.cargando = true;
      try {
        const response = await axios.get(
          "/api/tif/centralTrafico/getNovedades?page=" + page,
          {
            params: this.filtros,
          },
        );
        this.novedades = response.data;
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Error al cargar los datos: " +
            (error.response?.data?.message || error.message),
        });
      } finally {
        this.cargando = false;
      }
    },

    getSelectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
      this.cargarDatos();
    },

    getSelectVehiculo() {
      this.filtros.vehiculo_id = null;
      if (this.vehiculo) {
        this.filtros.vehiculo_id = this.vehiculo.id;
      }
      this.cargarDatos();
    },

    getSelectRemolque() {
      this.filtros.remolque_id = null;
      if (this.remolque) {
        this.filtros.remolque_id = this.remolque.id;
      }
      this.cargarDatos();
    },

    getSelectConductor() {
      this.filtros.conductor_id = null;
      if (this.conductor) {
        this.filtros.conductor_id = this.conductor.id;
      }
      this.cargarDatos();
    },

    limpiarFiltros() {
      this.filtros = {
        empresa_id: null,
        vehiculo_id: null,
        remolque_id: null,
        conductor_id: null,
        fecha_inicial: null,
        fecha_final: null,
        tipo_servicio: null,
        entidad_id: null,
      };
      this.cargarDatos();
    },

    getEstadoColor(estado) {
      const colores = {
        1: "bg-primary", // Iniciado
        2: "bg-info", // En Sitio Cargue
        3: "bg-warning", // En Sitio Descargue
        4: "bg-success", // En Sitio Cargue o Descargue
        5: "bg-secondary", // En Sitio Disponibilidad
        6: "bg-danger", // En Sit io Indisponibilidad
        7: "bg-dark", // Transito
      };
      return colores[estado] || "bg-secondary";
    },

    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>
